export default "__VITE_ASSET__CK3cz9pp__"